import { Botao } from '@mymaxx/ui';
import { useQuery } from '@tanstack/react-query';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router';
import { chatApi } from '../lib/chat-api';

/**
 * O aviso de privacidade, para o cliente ler.
 *
 * Existe porque o sistema registra o aceite de uma versão desde sempre, e aceitar algo que
 * não se pode ler não é consentimento. O texto vem do painel: o admin publica e aparece
 * aqui, sem subir o sistema.
 */
export function Privacidade() {
  const politica = useQuery({ queryKey: ['privacidade'], queryFn: chatApi.privacidade });

  return (
    <main className="mx-auto min-h-dvh max-w-2xl space-y-6 px-5 py-8">
      <header className="flex items-center gap-3">
        <Link to="/" aria-label="Voltar" className="text-neutral-500 hover:text-neutral-800">
          <ArrowLeft size={20} />
        </Link>
        <h1 className="text-xl font-semibold">Aviso de privacidade</h1>
      </header>

      {politica.isPending && <p className="text-sm text-neutral-500">Carregando…</p>}

      {politica.isSuccess && !politica.data.texto && (
        <p className="text-sm text-neutral-600 dark:text-neutral-400">
          Este aviso ainda não foi publicado. Fale com nosso atendimento para receber uma cópia.
        </p>
      )}

      {politica.data?.texto && (
        <>
          <p className="text-xs text-neutral-500">
            Versão {politica.data.versao}
            {politica.data.atualizadoEm &&
              ` · atualizado em ${new Date(politica.data.atualizadoEm).toLocaleDateString('pt-BR')}`}
          </p>
          {/* `whitespace-pre-wrap` preserva os parágrafos como o admin escreveu: o texto é
              guardado cru, e transformá-lo em HTML aqui abriria a porta para injeção. */}
          <div className="text-sm leading-relaxed whitespace-pre-wrap text-neutral-700 dark:text-neutral-300">
            {politica.data.texto}
          </div>
        </>
      )}

      <Link to="/" className="block">
        <Botao variante="secundario" className="w-full">
          Voltar ao início
        </Botao>
      </Link>
    </main>
  );
}
